import { useEffect, useState } from 'react';

function JoinPopup({ joining }) {
    const [date, setDate] = useState();
    const [Entity, setEntity] = useState();
    const [disable, setDisable] = useState(true);
    const [time, setTime] = useState();
    const [IstTime, setIstTime] = useState();
    const [address, setAddress] = useState();
    const [floor, setFloor] = useState('');
    const [validation, setValidation] = useState({
        date: '',
        entity: '',
        floor: '', // New validation message for floor
    });

    useEffect(() => {
        validates();
    }, [date, Entity, time, address]);

    const validates = () => {
        let istStartTime;
        let result = true;
        if (date == undefined || date == '') {
            //setValidation((validate) => ({ ...validate, date: 'Select a valid date' }));
            result = false;
        }
        if (Entity == undefined || Entity == '') {
            //setValidation((validate) => ({ ...validate, entity: 'Select a valid Entity' }));
            result = false;
        }
        if (time == undefined || time == '') {
            result = false;
        } else {
            let starttimevalue = time;
            let end = starttimevalue.split(':');

            var currentTime = new Date();

            let arr = currentTime.toString().split(' ');
            arr[4] = `${end[0]}:${end[1]}:00`;
            currentTime = new Date(arr.join(' '));

            var currentOffset = currentTime.getTimezoneOffset();

            var ISTOffset = 330;

            var ISTTime = new Date(currentTime.getTime() + (ISTOffset + currentOffset) * 60000);

            var hoursIST = ISTTime.getHours();
            var minutesIST = ISTTime.getMinutes();

            istStartTime = hoursIST + ':' + minutesIST;

            setIstTime(istStartTime);
        }
        if (address == undefined || address == '' || address == 'Select') {
            // setValidation((validate) => ({ ...validate, date: 'Select a valid date' }));
            result = false;
        }

        if (floor && (floor === undefined || floor === '' || floor === 'Select')) {
            setValidation((validate) => ({ ...validate, floor: 'Select a valid floor' }));
        } else {
            setValidation((validate) => ({ ...validate, floor: '' }));
        }

        if (result) {
            setDisable(false);
        } else {
            setDisable(true);
        }
        if (
            address !== undefined &&
            address !== '' &&
            address !== 'Select' &&
            date !== undefined &&
            date !== '' &&
            time !== undefined &&
            time !== '' &&
            Entity !== undefined &&
            Entity !== '' &&
            floor !== undefined &&
            floor !== '' &&
            floor !== 'Select'
        ) {
            joining(date, Entity, istStartTime, address, floor);
            // joining(date, Entity, istStartTime, address);
        }

        if (result) {
            setDisable(false);
        }
    };
    const validate = () => {
        let istStartTime;
        let result = true;
        if (date == undefined || date == '') {
            //setValidation((validate) => ({ ...validate, date: 'Select a valid date' }));
            result = false;
        }
        if (Entity == undefined || Entity == '') {
            //setValidation((validate) => ({ ...validate, entity: 'Select a valid Entity' }));
            result = false;
        }
        if (time == undefined || time == '') {
            result = false;
        } else {
            let starttimevalue = time;
            let end = starttimevalue.split(':');

            var currentTime = new Date();

            let arr = currentTime.toString().split(' ');
            arr[4] = `${end[0]}:${end[1]}:00`;
            currentTime = new Date(arr.join(' '));

            var currentOffset = currentTime.getTimezoneOffset();

            var ISTOffset = 330;

            var ISTTime = new Date(currentTime.getTime() + (ISTOffset + currentOffset) * 60000);

            var hoursIST = ISTTime.getHours();
            var minutesIST = ISTTime.getMinutes();

            istStartTime = hoursIST + ':' + minutesIST;

            setIstTime(istStartTime);
        }
        if (address == undefined || address == '' || address == 'Select') {
            // setValidation((validate) => ({ ...validate, date: 'Select a valid date' }));
            result = false;
        }
        if (floor && (floor === undefined || floor === '' || floor === 'Select')) {
            setValidation((validate) => ({ ...validate, floor: 'Select a valid floor' }));
        } else {
            setValidation((validate) => ({ ...validate, floor: '' }));
        }
        if (result) {
            setDisable(false);
        } else {
            setDisable(true);
        }
        if (
            address !== undefined &&
            address !== '' &&
            address !== 'Select' &&
            date !== undefined &&
            date !== '' &&
            time !== undefined &&
            time !== '' &&
            Entity !== undefined &&
            Entity !== '' &&
            floor !== undefined &&
            floor !== ''
        ) {
            joining(date, Entity, istStartTime, address, floor);
        }

        if (result) {
            setDisable(false);
        }
    };

    return (
        <div
            className="modal fade "
            id="exampleModalJoin"
            // style={{ display: 'block' }}
            tabIndex={-1}
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
        >
            <div className="modal-dialog addfamily-popup modal-dialog-centered">
                <div className="modal-content px-2">
                    <div className="modal-header border-0 px-2">
                        <h5 className="modal-title addfam-text-blue bold-text font-16" id="exampleModalLabel">
                            Announce Joining Date
                        </h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                    </div>
                    <div className="modal-body px-2">
                        <div className="row py-2 align-items-center">
                            <div className="col-lg-4 col-md-4 col-sm-12">
                                <label
                                    htmlFor="selectreason"
                                    className="form-label form-label-sm addfamily-label-clr semibold-text font-13"
                                >
                                    Schedule Date
                                    
                                </label>
                                <span className="required">*</span>
                            </div>
                            <div className="col-lg-8 col-md-8 col-sm-12">
                                <input
                                    type="date"
                                    className="form-control hive-form-control"
                                    id="selectreason"
                                    onChange={(e) => {
                                        setDate(e.target.value);
                                        setValidation((validate) => ({ ...validate, date: '' }));
                                    }}
                                    aria-label="Default select example"
                                    min={new Date().toISOString().split('T')[0]}
                                    onKeyDown={(e)=>{
                                        e.preventDefault();
                                    }}
                                />
                                <div>
                                    <span className="text-danger">{validation.date}</span>
                                </div>
                            </div>
                        </div>
                        <div className="row py-2 align-items-center">
                            <div className="col-lg-4 col-md-4 col-sm-12">
                                <label
                                    htmlFor="selectreason"
                                    className="form-label form-label-sm addfamily-label-clr semibold-text font-13"
                                >
                                    Entity
                                </label>
                                <span className="required">*</span>
                            </div>
                            <div className="col-lg-8 col-md-8 col-sm-12">
                                <select
                                    className="form-select hive-form-select"
                                    onChange={(e) => {
                                        setEntity(e.target.value);
                                        setValidation((validate) => ({ ...validate, entity: '' }));
                                    }}
                                    id="departmentID"
                                    name="dropdown"
                                // value={formData.departmentID + '@' + previewData.departmentID}
                                >
                                    <option value="Select">Select</option>
                                    <option value="AVASEZ">AVASEZ</option>
                                    <option value="AVA">AVA</option>
                                    <option value="AVI">AVI</option>
                                </select>
                                <div>
                                    <span className="text-danger">{validation.date}</span>
                                </div>
                            </div>
                        </div>
                        <div className="row py-2 align-items-center">
                            <div className="col-lg-4 col-md-4 col-sm-12">
                                <label
                                    htmlFor="selectreason"
                                    className="form-label form-label-sm addfamily-label-clr semibold-text font-13"
                                >
                                    Schedule Time
                                </label>
                                <span className="required">*</span>
                            </div>
                            <div className="col-lg-8 col-md-8 col-sm-12">
                                <input
                                    type="time"
                                    className="form-control hive-form-control"
                                    id="selectreason"
                                    onChange={(e) => {
                                        setTime(e.target.value);
                                    }}
                                    aria-label="Default select example"
                                />
                            </div>
                        </div>
                        <div className="row py-2 align-items-center">
                            <div className="col-lg-4 col-md-4 col-sm-12">
                                <label
                                    htmlFor="selectreason"
                                    className="form-label form-label-sm addfamily-label-clr semibold-text font-13"
                                >
                                    Venue
                                </label>
                                <span className="required">*</span>
                            </div>
                            <div className="col-lg-8 col-md-8 col-sm-12">
                                <select
                                    className="form-select hive-form-select"
                                    onChange={(e) => {
                                        setAddress(e.target.value);
                                    }}
                                    id="departmentID"
                                    name="dropdown"
                                >
                                    <option value="Select">Select</option>
                                    <option value="Bayline">Bayline</option>
                                    <option value="SSPDL">SSPDL</option>
                                </select>
                            </div>
                        </div>
                        <div className="row py-2 align-items-center">
                            <div className="col-lg-4 col-md-4 col-sm-12">
                                <label htmlFor="selectFloor" className="form-label form-label-sm addfamily-label-clr semibold-text font-13">
                                    Floor
                                </label>
                                <span className="required">*</span>
                            </div>
                            <div className="col-lg-8 col-md-8 col-sm-12">
                                <select
                                    className="form-select hive-form-select"
                                    onChange={(e) => {
                                        //debugger;
                                        setFloor(e.target.value);
                                        setValidation((validate) => ({ ...validate, floor: '' }));
                                    }}
                                    id="selectFloor"
                                    name="dropdown"
                                    value={floor}
                                >
                                    <option value="Select">Select</option>
                                    <option value="3rd Floor">3rd Floor</option>
                                    <option value="4rd Floor">4rd Floor</option>
                                    <option value="5th Floor">5th Floor</option>
                                    <option value="6rd Floor">6rd Floor</option>
                                    <option value="7th Floor">7th Floor</option>
                                </select>
                                <div>
                                    <span className="text-danger">{validation.floor}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer border-0">
                        <button type="button" className="btn cancel-button bold-text font-14 me-3" data-bs-dismiss="modal">
                            Cancel
                        </button>
                        <button
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            className="btn hive-btn-primary bold-text font-14"
                            onClick={() => {
                                validate();
                            }}
                            disabled={disable}
                        >
                            Announce
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default JoinPopup;
